import React, { useState, useEffect, lazy, useRef } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Col, Dropdown, Form, Image, Row, Button } from 'react-bootstrap';
import Avatar from './avatar.jpg';
import ChatImage from './chat-image.png';
import {
  alertAtom,
  leadDetailObjAtom,
  messageListAtom,
  userDetailAtom,
} from '../../Services/_states';
import { InterveneActions } from '../../Services/_actions/Intervene/intervene.actions';
import './chat_css.css';
import SendTemplateModal from '../Modals/SendTemplateModal';
import MessageNode from './MessageNode';
import SweetAlert from '../Shared/Notification';
const ModalForms = lazy(() => import('../../components/Shared/Modals'));
import { dateFormate } from '../../utils/helper';
import FileUploadPreview from '../Shared/FileUploadPreview';
import { renderToolTip } from '../../utils/helper';
import { useScreenshot } from 'use-react-screenshot';
import { LeadFormActions } from '../../Services/_actions';
import { CallingModal } from '../Modals/CallingModal/CallingModal';
import DataNotFound from '../Shared/DataNotFound';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';  
import MusicNoteIcon from '@mui/icons-material/MusicNote';  
import DescriptionIcon from '@mui/icons-material/Description'; 
import ImageIcon from '@mui/icons-material/Image'; 

const ChatBox = () => {
  const actions = InterveneActions();
  const leadFormActions = LeadFormActions();
  const userDetails = useRecoilValue(userDetailAtom);
  const messageList = useRecoilValue(messageListAtom);
  const [isLoading, setIsLoading] = useRecoilState(alertAtom);
  const leadDetails = useRecoilValue(leadDetailObjAtom);
  const messageBoxRef = useRef(null);
  const uploadImageRef = useRef(null);
  const uploadDocumentsRef = useRef(null);
  const uploadAudioRef = useRef(null);
  const uploadVideoRef = useRef(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [sendMessage, setSendMessage] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [docType, setDocType] = useState('');
  // const [modalShow_temp, setModalShow_temp] = useState(false);
  const [modalShow_call, setModalShow_call] = useState(false);
  const [lastSeenDate, setLastSeenDate] = useState('');
  const [screenCapture, setScreenCapture] = useState('');
  const [captureModal, setCaptureModal] = useState(false);
  const chatBoxref = useRef(null);
  const [screenShot, takeScreenshot] = useScreenshot();
  const [screenMode, setScreenMode] = useState(false);

  const handleCapture = async (uri) => {
    const screenshot = await takeScreenshot(chatBoxref.current);
    setScreenCapture(screenshot);
    setCaptureModal(true);
  };
  const handleSave = async () => {
    await fetch(screenCapture)
      .then((res) => res.blob())
      .then((blob) => {
        let form = new FormData();
        const timestamp = new Date().getTime(); // Get current timestamp
        const filename = `screenshot_${timestamp}.png`;
        form.append('file', blob, filename);
        leadFormActions.uploadLeadImageById(leadDetails?.id, form);
      })
      .catch((error) => {
        console.error('Error converting screenshot to blob:', error);
      });
    setCaptureModal(false);
  };

  const handleFileChange = (e) => {
    setDocType(e.target.accept);
    let ImagesArray = Object.entries(e.target.files).map((e) => e[1]);
    setSelectedFiles([...selectedFiles, ...ImagesArray]);
  };
  function deleteFile(e) {
    let s = selectedFiles.filter((item, index) => index !== e);
    setSelectedFiles(s);
    if (s.length <= 0) setDocType('');
  }

  const getMessagesByNumber = async (filter) => {
    setIsLoading(true);
    if (filter?.phone_number) await actions.getUserMessages(filter);
  };

  const sendMessageByNumber = async () => {
    let form = new FormData();
    form.append('phone_number', userDetails?.phone_number);
    switch (docType) {
      case 'image/*':
        form.append('file', selectedFiles[0]);
        form.append('caption', sendMessage);
        form.append('type', 'image');
        break;
      case '.doc, .docx, .pdf, .txt':
        form.append('file', selectedFiles[0]);
        // form.append('caption', sendMessage);
        form.append('type', 'file');
        break;
      case 'audio/*':
        form.append('file', selectedFiles[0]);
        // form.append('caption', sendMessage);
        form.append('type', 'audio');
        break;
      case 'video/*':
        form.append('file', selectedFiles[0]);
        // form.append('caption', sendMessage);
        form.append('type', 'video');
        break;
      default:
        form.append('text', sendMessage);
        form.append('type', 'text');
        break;
    }
    if (userDetails?.phone_number) {
      await actions.sendMessageV1(form);
      setSendMessage('');
      setSelectedFiles([]);
      setDocType('');
    } else SweetAlert('Error', 'error');
  };

  const scrollToBottom = () => {
    if (messageBoxRef.current) {
      if (pageNumber === 1) {
        messageBoxRef.current.scrollTop = messageBoxRef.current.scrollHeight;
        const reversedArray = [...messageList?.messages].reverse();
        let check = true;
        reversedArray.reverse().forEach((element) => {
          if (element?.origin === 'INBOUND' && check) {
            setLastSeenDate(element?.created_at);
            check = false;
          }
        });
      } else messageBoxRef.current.scrollTop = messageBoxRef.current.scrollHeight / 3;
    }
  };

  const handleScroll = () => {
    if (messageBoxRef.current && messageList?.messages.length < messageList?.total_count) {
      const { scrollTop, scrollHeight, clientHeight } = messageBoxRef.current;
      if (scrollTop === 0) {
        setPageNumber(pageNumber + 1);
        getMessagesByNumber({ ...userDetails, page: pageNumber + 1 });
      }
    }
  };
  const enterFullscreen = () => {
    const elem = chatBoxref.current;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    }
  };
  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  };
  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      setScreenMode(true);
      enterFullscreen();
    } else {
      setScreenMode(false);
      exitFullscreen();
    }
  };


  useEffect(() => {
    scrollToBottom();
  }, [messageList]);

  useEffect(() => {
    setPageNumber(1);
    getMessagesByNumber({ ...userDetails, page: 1 });
  }, [userDetails]);
  return (
    <>
      <div ref={chatBoxref}>
        {Object.keys(userDetails).length !== 0 ? (
          <>
            <div className="center-header">
              <div className="current-user-info">
                <div className="current-user-avatar">
                  <img src={Avatar} className="avatar-img" />
                </div>
                <div>
                  <h5 className="user-name-top-head">
                    {userDetails?.whatsapp_name
                      ? `${userDetails?.whatsapp_name} (${userDetails?.phone_number})`
                      : userDetails?.phone_number
                    }
                  </h5>
                  {userDetails?.updated_at && (
                    <p className="text-dark" style={{ fontSize: 'small',color:'black' }}>
                      Last Seen {dateFormate(userDetails?.updated_at, 'DD/MM/YYYY hh:mm A')}
                    </p>
                  )}
                </div>
              </div>
              <div className="current-user-actions">
                <div className="icon-icons">
                  <span
                    onClick={(e) => {
                      getMessagesByNumber({ ...userDetails, page: 1 });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className={`bi bi-arrow-clockwise ${isLoading ? 'rotate-animation' : ''}`}
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                      />
                      <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                    </svg>
                  </span>
                  <span
                    onClick={(e) => {
                      window.open(
                        "https://www.google.com/maps/place/0%C2%B000'00.0%22N+0%C2%B000'00.0%22E/@0,0,17z/data=!3m1!4b1?entry=ttu",
                        '_blank',
                        'width=1200,height=800'
                      );
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-geo-alt-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
                    </svg>
                  </span>{' '}
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      handleCapture();
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-camera2" viewBox="0 0 16 16">
                      <path d="M5 8c0-1.657 2.343-3 4-3V4a4 4 0 0 0-4 4" />
                      <path d="M12.318 3h2.015C15.253 3 16 3.746 16 4.667v6.666c0 .92-.746 1.667-1.667 1.667h-2.015A5.97 5.97 0 0 1 9 14a5.97 5.97 0 0 1-3.318-1H1.667C.747 13 0 12.254 0 11.333V4.667C0 3.747.746 3 1.667 3H2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1h.682A5.97 5.97 0 0 1 9 2c1.227 0 2.367.368 3.318 1M2 4.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M14 8A5 5 0 1 0 4 8a5 5 0 0 0 10 0" />
                    </svg>
                  </span>
                  <span onClick={() => { handleFullscreen() }}>
                    {screenMode ?
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-fullscreen-exit" viewBox="0 0 16 16">
                        <path d="M5.5 0a.5.5 0 0 1 .5.5v4A1.5 1.5 0 0 1 4.5 6h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5m5 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 10 4.5v-4a.5.5 0 0 1 .5-.5M0 10.5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 6 11.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5m10 1a1.5 1.5 0 0 1 1.5-1.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0z" />
                      </svg>
                      :
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrows-fullscreen" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707" />
                      </svg>
                    }
                  </span>
                </div>
              </div>
            </div>
            <div className="messages-area">
              <div className={`recent-msgs ${screenMode ? 'chatbox-fullscreen' : ''}`} ref={messageBoxRef} onScroll={handleScroll}>
                {messageList?.messages &&
                  messageList?.messages?.map((message, index) => {
                    return (
                      <div key={index}>
                        <MessageNode message={message} />
                      </div>
                    );
                  })}
              </div>
              {selectedFiles.length > 0 && (
                <FileUploadPreview selectedFiles={selectedFiles} deleteFile={deleteFile} />
              )}
              <div className="msger-inputarea">
                <input
                  type="text"
                  className="msger-input"
                  placeholder="Type message..."
                  value={sendMessage}
                  onChange={(e) => {
                    setSendMessage(e?.target?.value);
                  }}
                  onKeyDown={(e) => {
                    e?.key === 'Enter' && sendMessage?.trim()?.length ? sendMessageByNumber() : '';
                  }}
                />
                <Dropdown>
                  <Dropdown.Toggle className="btn-attachment">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0" />
                      </svg>
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1">
                      <Form.Group
                        controlId="formFile"
                        className="mb-3"
                        onClick={() => uploadImageRef.current.click()}
                      >
                        <div
                          style={{
                            display: 'flex',
                            // justifyContent:"space-between",
                            alignItems: 'center',
                          }}
                        >
                          <span style={{ color: '#333', fontSize: '21px', marginRight: '10px' }}>
                            <ImageIcon />
                          </span>

                          <Form.Text style={{ fontSize: '17px' }}>Image</Form.Text>
                          <Form.Control
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            accept="image/*"
                            style={{ display: 'none' }}
                            ref={uploadImageRef}
                          />
                        </div>
                      </Form.Group>
                    </Dropdown.Item>
                    <Dropdown.Item href="#/action-2">
                      <Form.Group
                        controlId="formFile"
                        className="mb-3"
                        onClick={() => uploadDocumentsRef.current.click()}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <span style={{ color: '#333', fontSize: '21px', marginRight: '10px' }}>
                            <DescriptionIcon />
                          </span>
                          <Form.Text style={{ fontSize: '17px' }}>Documents</Form.Text>
                          <Form.Control
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            accept=".doc, .docx, .pdf, .txt"
                            style={{ display: 'none' }}
                            ref={uploadDocumentsRef}
                          />
                        </div>
                      </Form.Group>
                    </Dropdown.Item>
                    <Dropdown.Item href="#/action-2">
                      <Form.Group
                        controlId="formFile"
                        className="mb-3"
                        onClick={() => uploadAudioRef.current.click()}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <span style={{ color: '#333', fontSize: '21px', marginRight: '10px' }}>
                            <MusicNoteIcon />
                          </span>

                          <Form.Text style={{ fontSize: '17px' }}>Audio</Form.Text>
                          <Form.Control
                            type="file"
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                            ref={uploadAudioRef}
                            accept="audio/*"
                          />
                        </div>
                      </Form.Group>
                    </Dropdown.Item>
                    <Dropdown.Item href="#/action-2">
                      <Form.Group
                        controlId="formFile"
                        className="mb-3"
                        onClick={() => uploadVideoRef.current.click()}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <span style={{ color: '#333', fontSize: '21px', marginRight: '10px' }}>
                            <InsertDriveFileIcon />
                          </span>

                          <Form.Text style={{ fontSize: '17px' }}>Video</Form.Text>
                          <Form.Control
                            type="file"
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                            ref={uploadVideoRef}
                            accept="video/*"
                          />
                        </div>
                      </Form.Group>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                {sendMessage?.trim()?.length || selectedFiles?.length ? (
                  <span
                    style={{
                      color: '#333',
                      fontSize: '21px',
                      marginRight: '10px',
                      cursor: 'pointer',
                      transform: 'rotate(45deg)',
                    }}
                    onClick={(e) => {
                      sendMessageByNumber();
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-send-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z" />
                    </svg>
                  </span>
                ) : (
                  ''
                )}
              </div>
            </div>
          </>
        ) : (
          <div className="non-user-selected">
            <DataNotFound message="No Data Found !" />
          </div>
        )}
      </div>
      {modalShow_call && (
        <ModalForms
          show={modalShow_call}
          handleClose={(e) => {
            setModalShow_call(false);
          }}
          modalBody={<CallingModal userDetails={userDetails} />}
          modalHeader={'Quick Call'}
          modalId={'calling'}
          modalclassName={''}
          size="sm"
        />
      )}
      {screenCapture && (
        <ModalForms
          show={captureModal}
          handleClose={(e) => {
            setCaptureModal(false);
            setScreenCapture('');
          }}
          modalBody={
            <>
              <center>
                <img src={screenCapture} alt="react-screen-capture" />
                <p>
                  {' '}
                  <Button onClick={handleSave}>Upload</Button>
                </p>
              </center>
            </>
          }
          modalHeader={'Screenshot'}
          modalId={'Screenshot'}
          modalclassName={''}
          size="m"
        />
      )}
    </>
  );
};

export default ChatBox;
